import React from 'react';
import PropTypes from 'prop-types';
import { FDSecondaryActionIconButton, FDStack } from '@facet-wealth/design';

export const PillarQueries = ({ collection: queryCollection, onSubmit }) => {
  const currPillar = queryCollection.query('getSelectedPillar', (_, { query }) => query, () => undefined);

  if (currPillar) {
    return (
      <FDStack alignItems={'center'}>
        {queryCollection.query('getPreviousPillar', (link) => (
          <FDSecondaryActionIconButton icon={'chevronLeft'} onClick={() => onSubmit(link)} />
        ), () => null)}
        {queryCollection.query('getNextPillar', (link) => (
          <FDSecondaryActionIconButton icon={'chevronRight'} onClick={() => onSubmit(link)} />
        ), () => null)}
      </FDStack>
    );
  }

  const selectedMonth = queryCollection.query('getSelectedMonth', (_, { query }) => query, () => undefined);

  if (selectedMonth) {
    return (
      <FDStack alignItems={'center'}>
        {queryCollection.query('getPreviousMonth', (link) => (
          <FDSecondaryActionIconButton icon={'chevronLeft'} onClick={() => onSubmit(link)} />
        ), () => null)}
        {queryCollection.query('getNextMonth', (link) => (
          <FDSecondaryActionIconButton icon={'chevronRight'} onClick={() => onSubmit(link)} />
        ), () => null)}
      </FDStack>
    );
  }

  return null;
};

PillarQueries.defaultProps = {
};

PillarQueries.propTypes = {
  collection: PropTypes.object.isRequired,
  onSubmit: PropTypes.object.isRequired,
};
